<pr-input-map
  (placeChanged)="toValue = $event"
  placeholder="Enter to address..."
  label="Saisissez l’adresse de votre fiscalité"
  formGroupName="fiscalAddress"
  [isGMaps]="!isSwisslifeProduct"
  [isSwisslifeProduct]="isSwisslifeProduct"
  [countries]="countries"
  [derrors]="derrors"
  [isDefault]="false"
  documentMapId="map2"
  [hidden]="
    form.get('fiscalAddressIsNotContactAddress')?.value == false ||
    form.get('fiscalAddressIsNotContactAddress')?.value == undefined
  "
>
</pr-input-map>
